import baseMerge from "./_baseMerge.js";
import createAssigner from "./_createAssigner.js";
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
export {
  merge as default
};
//# sourceMappingURL=merge.js.map
